import {css, html} from "@isceco/widget-library2/external/lit"
import '../../../../components/RadioGroupVertical/CustomRadioGroupVertical'
import '@isceco/widget-library2/basic-elements/Form/Form'
import '@isceco/widget-library2/basic-elements/DropdownMultiselect/DropdownMultiselect'
import '@isceco/widget-library2/basic-elements/FileInput/FileInput'
import FormComponent from "../../../../components/FormComponent";
import createProjectPRODEX from "./projects/createProjectPRODEX";
import createProjectRaumfahrttechnologien from "./projects/createProjectRaumfahrttechnologien";
import createProjectNAR from "./projects/createProjectNAR";
import SbfiProjektfinanzierungsgesuchService from "./SbfiProjektfinanzierungsgesuchService";

export default class Projektfinanzierungsgesuch extends FormComponent {

  static WEBSITE_PATTERN = '^(https?:\\/\\/)?(www\\.)?([a-zA-Z0-9\\-]+\\.)+[a-zA-Z]{2,}(\\/.*)?$';
  static PHONE_PATTERN_INTL_CH = '^(?:\\+\\d\\d|00\\d\\d|0)(?:\\s?\\d){9,15}$';

  constructor() {
    super();
  }

  get translationFile() {
    return './views/WBF/SBFI/Projektfinanzierungsgesuch/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.initialized.then(() => {
      this.reload()
    })
  }

  get css() {
    return css`
      .form-elements isceco-card {
        margin-bottom: var(--isceco-space-300);
      }

      .form-card {
        display: flex;
        flex-flow: column nowrap;
        gap: var(--isceco-space-200);
      }

      .cols {
        display: flex;
        flex-direction: column;
        gap: 1rem;
      }

      .cols > * {
        flex: 1;
        min-width: 0;
      }

      @media (min-width: 768px) {
        .cols {
          flex-direction: row;
        }
      }

      isceco-card .header {
        margin-bottom: 0;
      }

      .margin-top-0 {
        margin-top: 0
      }

      .margin-bottom-0 {
        margin-bottom: 0
      }

      li {
        list-style: disc;
        padding: 0.5rem 0;
      }
    `
  }

  getTemplate() {
    const submitKey = this.preview ? 'form.button.submit' : 'form.button.preview'
    return html`
      <isceco-title id="page-title"
                    text="${this.i18n.translate('page.title')}"
      ></isceco-title>
      <eform-submit-status></eform-submit-status>
      <isceco-form id="sbfi-projektfinanzierungsgesuch-form"
                   include-disabled
                   submit-button-text="${this.i18n.translate(submitKey)}"
                   @submit="${e => this._submit(e)}">
        <div slot="buttons">
          <isceco-button text="${this.i18n.translate('form.button.abort')}"
                         @click="${() => this.abort()}"
                         variant="secondary"
                         .disabled="${!this.preview}"
          ></isceco-button>
        </div>
        <div slot="form-elements" class="form-elements">
          ${this.getFormElements()}
        </div>
      </isceco-form>`
  }

  _submit = event => {
    if (!this.preview) {
      this.preview = true
      this.render()
      return
    }

    new SbfiProjektfinanzierungsgesuchService().submit(event.detail, event.target)
  }

  getFormElements = () => {
    return html`
      ${this._renderOverviewAndRequirements()}
      ${this._renderRecipient()}
      ${this._renderGesuchsteller()}
      ${this._renderKontaktperson()}
      ${this._renderProjektfinanzierungsgesuch()}
      ${this._getProjectTemplate()}`
  }

  _renderOverviewAndRequirements = () => {
    return html`
      <isceco-card text="${this.i18n.translate('sbfi.requirement.header')}" class="form-card">
        <p class="margin-top-0">${this.i18n.translate('sbfi.requirement.body')}</p>
        <div>
          <p class="margin-bottom-0">${this.i18n.translate('sbfi.requirement.body.list1.header')}</p>
          <ul>
            ${this._getLink(1, 'technology')}
            ${this._getLink(2, 'prodex')}
            ${this._getLink(3, 'nar')}
          </ul>

        </div>
        <div>
          <p class="margin-bottom-0">${this.i18n.translate('sbfi.requirement.body.list2.header')}</>
          <ul>
            <li>${this.i18n.translate('sbfi.requirement.body.list2.item1')}</li>
            <li>${this.i18n.translate('sbfi.requirement.body.list2.item2')}</li>
            <li>${this.i18n.translate('sbfi.requirement.body.list2.item3')}</li>
          </ul>
        </div>
      </isceco-card>`
  }

  _getLink(labelIndex, project) {
    const lang = window.getLanguage();
    const href = {
      'technology': {
        'de': 'https://www.sbfi.admin.ch/de/entwicklung-von-weltraumtechnologien-und-anwendungen',
        'fr': 'https://www.sbfi.admin.ch/fr/developpement-de-technologies-et-dapplications-spatiales',
        'it': 'https://www.sbfi.admin.ch/it/sviluppo-di-tecnologia-e-applicazioni-spaziali',
        'en': 'https://www.sbfi.admin.ch/en/space-technology-and-applications-development',
      },
      'prodex': {
        'de': 'https://www.sbfi.admin.ch/de/entwicklung-von-weltrauminstrumenten-prodex',
        'fr': 'https://www.sbfi.admin.ch/fr/programme-de-developpement-dexperiences-scientifiques-prodex',
        'it': 'https://www.sbfi.admin.ch/it/sviluppo-di-strumenti-spaziali-prodex',
        'en': 'https://www.sbfi.admin.ch/en/space-instrumentation-development-prodex',
      },
      'nar': {
        'de': 'https://www.sbfi.admin.ch/de/foerderung-von-nationalen-aktivitaeten-im-bereich-der-raumfahrt',
        'fr': 'https://www.sbfi.admin.ch/fr/encouragement-des-activites-nationales-dans-le-domaine-spatial',
        'it': 'https://www.sbfi.admin.ch/it/promozione-delle-attivita-nazionali-nel-settore-spaziale',
        'en': 'https://www.sbfi.admin.ch/en/support-for-national-research-activities-in-the-space-sector',
      }
    }[project][lang]
    return html`
      <li>${this.i18n.translate(`sbfi.requirement.body.list1.item${labelIndex}`)}
        <a href="${href}" target="_blank">(${this.i18n.translate('sbfi.requirement.body.list.link')})</a>
      </li>
    `
  }

  _renderRecipient = () => {
    return html`
      <isceco-card text="${this.i18n.translate('sbfi.recipient.title')}">
        <div>
          ${this.i18n.translate('sbfi.recipient.organization.name')}<br>
          ${this.i18n.translate('sbfi.recipient.organization.department')}<br>
          ${this.i18n.translate('sbfi.recipient.address.street')}<br>
          ${this.i18n.translate('sbfi.recipient.address.cityWithPostalCode')}<br>
        </div>
      </isceco-card>`
  }

  _renderGesuchsteller = () => {
    return html`
      <isceco-card text="${this.i18n.translate('form.title.request.gesuchsteller')}" class="form-card">
        <isceco-text-input label="${this.i18n.translate('form.request.gesuchsteller.firma')}"
                           name="gesuchsteller.firma"
                           required
                           .readonly="${this.preview}"
        ></isceco-text-input>
        <div class="cols">
          <isceco-text-input label="${this.i18n.translate('form.request.strasse')}"
                             name="gesuchsteller.strasse"
                             required
                             .readonly="${this.preview}"
                             style="flex-grow: 0.5"
          ></isceco-text-input>
          <isceco-text-input label="${this.i18n.translate('form.request.hausnummer')}"
                             name="gesuchsteller.hausnummer"
                             required
                             .readonly="${this.preview}"
                             style="flex-grow: 0.5"
          ></isceco-text-input>
        </div>
        <div class="cols">
          <isceco-number-input label="${this.i18n.translate('form.request.plz')}"
                               name="gesuchsteller.plz"
                               required
                               min="1000"
                               max="9999"
                               maximum-fraction-digits="0"
                               .readonly="${this.preview}"
                               style="flex-grow: 0.5"
          ></isceco-number-input>
          <isceco-text-input label="${this.i18n.translate('form.request.ort')}"
                             name="gesuchsteller.ort"
                             required
                             .readonly="${this.preview}"
                             style="flex-grow: 0.5"
          ></isceco-text-input>
        </div>
        <isceco-text-input label="${this.i18n.translate('form.request.gesuchsteller.webseite')}"
                           name="gesuchsteller.webseite"
                           pattern="${Projektfinanzierungsgesuch.WEBSITE_PATTERN}"
                           pattern-error-text="${this.i18n.translate('form.request.website.error')}"
                           .readonly="${this.preview}"
        ></isceco-text-input>
      </isceco-card>`
  }

  _renderKontaktperson = () => {
    return html`
      <isceco-card text="${this.i18n.translate('form.title.request.kontaktperson')}" class="form-card">
        <div class="cols">
          <isceco-text-input label="${this.i18n.translate('form.request.kontaktperson.vorname')}"
                             name="kontaktperson.vorname"
                             .value="${this._getAttributeFromTokenParsed('given_name')}"
                             required
                             .readonly="${this.preview}"
          ></isceco-text-input>
          <isceco-text-input label="${this.i18n.translate('form.request.kontaktperson.nachname')}"
                             name="kontaktperson.nachname"
                             .value="${this._getAttributeFromTokenParsed('family_name')}"
                             required
                             .readonly="${this.preview}"
          ></isceco-text-input>
        </div>
        <isceco-text-input label="${this.i18n.translate('form.request.kontaktperson.email')}"
                           name="kontaktperson.email"
                           .value="${this._getAttributeFromTokenParsed('email')}"
                           required
                           type="email"
                           pattern-error-text="${this.i18n.translate('form.request.email.error')}"
                           .readonly="${this.preview}"
        ></isceco-text-input>
        <isceco-text-input label="${this.i18n.translate('form.request.kontaktperson.tel')}"
                           name="kontaktperson.telefon"
                           pattern="${Projektfinanzierungsgesuch.PHONE_PATTERN_INTL_CH}"
                           pattern-error-text="${this.i18n.translate('form.request.phone.error')}"
                           .readonly="${this.preview}"
        ></isceco-text-input>
      </isceco-card>
    `
  }

  _renderProjektfinanzierungsgesuch = () => {
    return html`
      <isceco-card text="${this.i18n.translate('form.request.projektfinanzierungsgesuch.title')}">
        <isceco-dropdown label="${this.i18n.translate('form.request.projektfinanzierungsgesuch.body')}"
                         placeholder="${this.i18n.translate('form.request.projektfinanzierungsgesuch.placeholder')}"
                         name="project.project"
                         required
                         .readonly="${this.preview}"
                         .i18n="${this.i18n}"
                         .items="${this._getProjectOptions()}"
                         @change="${this._setProject}"
                         style="width: 100%"
        ></isceco-dropdown>
      </isceco-card>`
  }

  _projectKeyRaumfahrttechnologien = 'RAUMFAHRTTECHNOLOGIEN'
  _projectKeyPRODEX = 'PRODEX'
  _projectKeyNAR = 'NAR'

  _getProjectOptions = () => [
    {value: this._projectKeyRaumfahrttechnologien, name: 'form.request.projektfinanzierungsgesuch.project1.title'},
    {value: this._projectKeyPRODEX, name: 'form.request.projektfinanzierungsgesuch.project2.title'},
    {value: this._projectKeyNAR, name: 'form.request.projektfinanzierungsgesuch.project3.title'},
  ]

  _selectedProject;

  _setProject = ({detail: {valid, value}}) => {
    if (valid) {
      this._selectedProject = value;
      this.render();
    }
  }

  _getProjectTemplate = () => {
    return {
      [this._projectKeyRaumfahrttechnologien]: createProjectRaumfahrttechnologien(this),
      [this._projectKeyPRODEX]: createProjectPRODEX(this),
      [this._projectKeyNAR]: createProjectNAR(this)
    }[this._selectedProject] ?? html``
  }
}
customElements.define('eform-sbfi-projektfinanzierungsgesuch', Projektfinanzierungsgesuch)
